/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Mentions_Link_Space_TitleInputs */



/**
* | output |
* | --- |
* | "Link this space to the project?" |
*
* @param {Chat_Mentions_Link_Space_TitleInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const chat_mentions_link_space_title = /** @type {((inputs?: Chat_Mentions_Link_Space_TitleInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Mentions_Link_Space_TitleInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Diesen Space mit dem Projekt verknüpfen?")
	return /** @type {LocalizedString} */ ("Link this space to the project?")
});